var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilecoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 70,
    viewBox: "0 0 249 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H70V70H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_515)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 69.9994C15.75 69.9994 0 54.2494 0 34.8244C0.175 15.5744 15.75 -0.17557 35.175 -0.000569785C54.425 0.17443 70 15.7494 70 35.3494C69.825 54.4244 54.25 69.9994 35 69.9994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3249 30.8001L37.2749 36.4001L47.2499 37.8001L46.5499 40.4251L36.7499 39.0251C36.0499 41.3001 35.6999 43.7501 34.8249 45.8501C33.9499 48.3001 33.0749 50.7501 32.0249 53.0251C30.6249 56.0001 28.1749 58.1001 24.85 58.6251C22.925 58.9751 20.825 58.8001 19.25 57.5751C18.725 57.2251 18.2 56.5251 18.2 56.0001C18.2 55.3001 18.55 54.4251 19.075 54.0751C19.425 53.9001 20.3 54.0751 20.825 54.2501C21.35 54.7751 21.875 55.4751 22.225 56.1751C23.275 57.5751 24.675 57.7501 26.075 56.7001C27.65 55.3001 28.525 53.3751 29.05 51.4501C30.1 47.2501 31.1499 43.2251 32.0249 39.0251V38.3251L22.75 36.9251L23.1 34.3001L32.725 35.7001L33.9499 30.2751L23.975 28.7001L24.325 25.9001L34.6499 27.3001C34.9999 26.2501 35.1749 25.3751 35.5249 24.5001C36.3999 21.3501 37.275 18.2001 39.3749 15.4001C41.4749 12.6001 43.9249 10.8501 47.5999 11.0251C49.1749 11.0251 50.7499 11.5501 51.7999 12.7751C51.9749 12.9501 52.3249 13.3001 52.3249 13.6501C52.3249 14.3501 52.3249 15.2251 51.7999 15.7501C51.0999 16.2751 50.2249 16.1001 49.5249 15.4001C48.9999 14.8751 48.6499 14.3501 48.1249 13.8251C47.0749 12.4251 45.4999 12.2501 44.2749 13.4751C43.3999 14.3501 42.5249 15.5751 41.9999 16.8001C40.7749 20.4751 39.9 24.3251 38.6749 28.1751L48.2999 29.5751L47.5999 32.2001L38.3249 30.8001Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1477 49.282H100.736V35.202H116.444V30.582H100.736V22.046H117.412V17.382H95.1477V49.282Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.967 17.382V22.662H125.203V17.382H119.967ZM119.967 25.61V49.282H125.203V25.61H119.967Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.892 17.382H130.656V49.282H135.892V17.382Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.729 38.942C163.213 31.022 158.637 25.082 151.377 25.082C144.689 25.082 139.761 30.142 139.761 37.27C139.761 44.09 144.117 49.854 151.729 49.854C157.801 49.854 161.409 45.982 162.465 42.198H157.317C156.393 44.442 154.281 45.498 151.509 45.498C148.517 45.498 145.437 43.342 145.085 38.942H162.729ZM151.377 29.174C154.457 29.174 157.273 31.418 157.405 35.114H145.085C145.569 30.67 148.913 29.174 151.377 29.174Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.846 25.082C169.762 25.082 165.23 30.45 165.23 37.49C165.23 44.53 169.762 49.854 176.626 49.854C181.686 49.854 186.57 46.73 187.626 41.186H182.522C181.818 44.354 179.31 45.498 176.714 45.498C173.634 45.498 170.642 43.078 170.642 37.446C170.642 31.858 173.546 29.438 176.846 29.438C179.706 29.438 181.862 31.198 182.346 33.706H187.45C186.526 28.47 182.038 25.082 176.846 25.082Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.168 37.49C195.168 32.034 198.072 29.35 201.416 29.35C204.76 29.35 207.664 32.034 207.664 37.49C207.664 42.99 204.76 45.586 201.416 45.586C198.072 45.586 195.168 42.99 195.168 37.49ZM201.416 25.082C195.652 25.082 189.756 28.954 189.756 37.49C189.756 46.07 195.652 49.854 201.416 49.854C207.18 49.854 213.076 46.07 213.076 37.49C213.076 28.954 207.18 25.082 201.416 25.082Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.939 17.382V22.662H222.175V17.382H216.939ZM216.939 25.61V49.282H222.175V25.61H216.939Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.864 25.61H227.628V49.282H232.864V36.698C232.864 32.43 234.316 29.35 238.364 29.35C242.412 29.35 242.852 32.518 242.852 35.686V49.282H248.088V34.41C248.088 28.778 245.756 25.082 240.036 25.082C236.692 25.082 234.228 26.446 232.864 28.91V25.61Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilecoin);
export default __webpack_public_path__ + "static/media/filecoin.836d6e7982549b7d52b542872ba36fd0.svg";
export { ForwardRef as ReactComponent };